module.exports = __webpack_public_path__ + "static/media/pear-shader-leatherworking-tool.218dc503.webp";